// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1q1My","fileBtn":"File_fileBtn__27nRU","closeBtn":"File_closeBtn__YhHfN","fileSelected":"File_fileSelected__G3OEi","disabled":"File_disabled__bHgA0"};